import React from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { Layout, Menu, Button, Dropdown, Avatar, Space } from 'antd';
import { 
  HomeOutlined, 
  DashboardOutlined, 
  FileTextOutlined, 
  PlusOutlined,
  UserOutlined, 
  LogoutOutlined,
  LoginOutlined,
  RobotOutlined,
  ExperimentOutlined,
  BulbOutlined,
  MessageOutlined,
  BarChartOutlined,
  LineChartOutlined
} from '@ant-design/icons';
import { useAuth } from '../../contexts/AuthContext';

const { Header } = Layout;

const AppHeader = () => {
  const { isAuthenticated, currentUser, logout } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  
  // 获取当前路径
  const selectedKey = location.pathname;

  // 导航菜单项
  const menuItems = [
    {
      key: '/',
      label: <Link to="/">首页</Link>,
      icon: <HomeOutlined />
    }
  ];

  // 已登录用户显示的额外菜单项
  const authenticatedMenuItems = [
    {
      key: '/dashboard',
      label: <Link to="/dashboard">仪表盘</Link>,
      icon: <DashboardOutlined />
    },
    {
      key: '/emotion-records',
      label: <Link to="/emotion-records">情绪记录</Link>,
      icon: <FileTextOutlined />
    },
    {
      key: '/emotion-records/create',
      label: <Link to="/emotion-records/create">记录情绪</Link>,
      icon: <PlusOutlined />
    },
    {
      key: '/chat',
      label: <Link to="/chat">AI聊天</Link>,
      icon: <RobotOutlined />
    },
    {
      key: 'ai-assistants',
      label: 'AI助手',
      icon: <RobotOutlined />,
      children: [
        {
          key: '/ai/emotion-assistant',
          label: <Link to="/ai/emotion-assistant">情绪AI助手</Link>,
          icon: <MessageOutlined />
        },
        {
          key: '/ai/chat-mcp-assistant',
          label: <Link to="/ai/chat-mcp-assistant">聊天MCP助手</Link>,
          icon: <ExperimentOutlined />
        }
      ]
    },
    {
      key: 'analytics',
      label: '数据分析',
      icon: <BarChartOutlined />,
      children: [
        {
          key: '/analytics/emotions',
          label: <Link to="/analytics/emotions">情绪数据分析</Link>,
          icon: <LineChartOutlined />
        },
        {
          key: '/analytics/chats',
          label: <Link to="/analytics/chats">聊天数据分析</Link>,
          icon: <MessageOutlined />
        }
      ]
    }
  ];

  // 根据登录状态显示不同的菜单项
  const items = isAuthenticated 
    ? [...menuItems, ...authenticatedMenuItems]
    : menuItems;

  // 用户下拉菜单
  const userDropdownItems = [
    {
      key: 'profile',
      label: <Link to="/profile">个人设置</Link>,
      icon: <UserOutlined />
    },
    {
      key: 'logout',
      label: '退出登录',
      icon: <LogoutOutlined />,
      onClick: () => {
        logout();
        navigate('/');
      }
    }
  ];

  return (
    <Header style={{ position: 'fixed', zIndex: 1, width: '100%', display: 'flex', justifyContent: 'space-between', padding: '0 20px' }}>
      <div style={{ display: 'flex', alignItems: 'center' }}>
        <div className="logo" style={{ marginRight: '20px' }}>
          <Link to="/" style={{ color: 'white', fontSize: '18px', fontWeight: 'bold' }}>
            情绪记录应用
          </Link>
        </div>
        <Menu
          theme="dark"
          mode="horizontal"
          selectedKeys={[selectedKey]}
          items={items}
          style={{ flex: 1, minWidth: 'auto' }}
        />
      </div>
      <div>
        {isAuthenticated ? (
          <Dropdown menu={{ items: userDropdownItems }} placement="bottomRight">
            <Space style={{ cursor: 'pointer', color: '#fff' }}>
              <Avatar 
                src={currentUser?.imageUrl || null} 
                style={{ backgroundColor: currentUser?.imageUrl ? 'transparent' : '#1890ff' }}
                icon={!currentUser?.imageUrl && <UserOutlined />}
              />
              <span>{currentUser?.username || '用户'}</span>
            </Space>
          </Dropdown>
        ) : (
          <Space>
            <Button type="primary" icon={<LoginOutlined />} onClick={() => navigate('/login')}>
              登录
            </Button>
            <Button onClick={() => navigate('/register')}>
              注册
            </Button>
          </Space>
        )}
      </div>
    </Header>
  );
};

export default AppHeader; 